import promiseFor from "../../util/promise-for";

export class GALLERY_HINH {
    static readonly WIDTH = 687;
    static readonly HEIGHT = 830;

    static getMeta(url): Promise<any> {
        return new Promise((resolve, reject) => {
            let img = new Image();
            img.onload = () => resolve(img);
            img.onerror = reject;
            img.src = url;
        });
    }

    /**
     * lấy kích cỡ thật của hình ảnh
     */
    static getSizeImage = (images: any[], tieu_de): any[] => {
        // console.log(images);
        let items: any[] = [];
        items = images.map(x => {
            return {

                src: x.path,
                w: x.width,
                h: x.height,
                title: tieu_de
            }
        })
        return items;
        // return promiseFor(
        //     index => {
        //         return index < images.length
        //     }, index => {
        //         return GALLERY_HINH.getMeta(images[index])
        //             .then(value => {
        //                 // console.log(images[index]);
        //                 // console.log(value.width, value.height);
        //                 items.push({
        //                     src: images[index],
        //                     w: value.width,
        //                     h: value.height,
        //                     title: tieu_de || ''
        //                 })
        //                 index++
        //                 return index;
        //             })
        //     }
        //     , 0).then(value => {
        //         return items;
        //     })
    }
}